import $ from 'jquery';
import HcSticky from "hc-sticky";
import Component from "../models/Component";
import {$Doc} from "../utils/jQueryGlobals";

export default class Sticky extends Component {
  constructor(element, context) {
    super(element, context);
    $(() => {
      this.options = {
        top: 180,
        bottomEnd: 20,
        bottom: 20,
        followScroll: true,
        mobileFirst: true,
        disable: true,
        responsive: {
          768: {
            disable: false,
          }
        }
      };
      if (this.getData('stickTo')) {
        this.options.stickTo = $(this.getData('stick-to')).get(0);
      }
      this.init();
    });
  }

  init() {
    this.sticky = new HcSticky(this.element.get(0), this.options);
    $Doc.on('header_pin', () => {
      this.sticky.update({
        top: 149 + 20,
      });
    }).on('header_unpin', () => {
      this.sticky.update({
        top: 68 + 20,
      });
    }).on('refresh_sticky', () => {
      this.sticky.refresh();
    });
  }
}
